// extracted by mini-css-extract-plugin
module.exports = {"title":"Item_title__FaTXj"};